export enum TargetTrackerAppointmentPaymentType {
    ClearedPayment = 0,
    BankedPayment,
    SigningBooked,
    NextMonth,
    SigningPending,
    Debtor,
    NoLongerProceeding,
    ConsideringOptions,
}
